import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { InPostMark } from '@/components/inpost-logo';
import { ShopifyMark } from '@/components/shopify-logo';
import { Button } from '@/components/ui/button';

const CONNECTION_GUIDE_URL = '#todo';
const inlineLinkClasses = 'text-xs font-medium text-muted-foreground underline';

/**
 * Setup wizard step 1 - Figma 347-3084, reworked to the shared split layout.
 * Only shown standalone (not embedded): "Install" deep-links to the Shopify App
 * Store, after which the app reopens embedded with Shopify already connected.
 */
export function ConnectShopifyStep() {
  const { t } = useTranslation('setup');
  const appStoreUrl = import.meta.env.VITE_SHOPIFY_APP_STORE_URL as string | undefined;

  const handleInstall = () => {
    if (!appStoreUrl) {
      toast.error(t('shopify.unavailable'));
      return;
    }
    window.open(appStoreUrl, '_top');
  };

  return (
    <div className="flex flex-col gap-[17px]">
      {/* Shopify ↔ InPost pairing (echoes Figma 347-3125). */}
      <div className="flex items-center gap-3 self-start">
        <span className="flex size-[52px] items-center justify-center rounded-[12px] bg-[#f5f5f5]">
          <ShopifyMark className="size-7" />
        </span>
        <span className="text-2xl tracking-widest text-[#d4d4d4]" aria-hidden>
          ···
        </span>
        <span className="flex size-[52px] items-center justify-center rounded-[12px] bg-[#f5f5f5]">
          <InPostMark variant="white-bg" className="h-7 w-auto" />
        </span>
      </div>

      <h1 className="text-4xl font-medium tracking-[-0.9px] text-black">{t('shopify.title')}</h1>
      <p className="max-w-[495px] text-base text-muted-foreground">{t('shopify.description')}</p>

      <div className="flex items-center gap-6">
        <Button type="button" className="w-[186px] rounded-[10px]" onClick={handleInstall}>
          {t('shopify.install')}
        </Button>
        <a
          href={CONNECTION_GUIDE_URL}
          target="_blank"
          rel="noreferrer"
          className={inlineLinkClasses}
        >
          {t('shopify.readGuide')}
        </a>
      </div>
    </div>
  );
}
